import axios from 'axios'

export default {
  namespaced: true,
  state: {
    lessons: [],
    loading: false,
    activeLesson: null
  },
  mutations: {
    loading(state, value) {
      state.loading = value
    },
    lessons(state, value) {
      state.lessons = value
    },
    set_active(state, value) {
      state.activeLesson = value
    }
  },
  actions: {
    fetchItem({commit, state}, id) {
      return axios.get('/lesson/' + id)
        .then(({data}) => {
          return Promise.resolve(data)
        })
    }
  },
  getters: {
    lessons: state => state.lessons,
    loading: state => state.loading,
    active: state => state.activeLesson
  }
}
